(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-history"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.getElementById('AboutHistory-{{ section.id }}');
    if (!root) return;

    const timeline = root.querySelector('[data-history-timeline]');
    const progress = root.querySelector('[data-history-progress]');
    const milestones = [...root.querySelectorAll('[data-history-milestone]')];
    if (!timeline || !progress || !milestones.length) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const update = () => {
      const rect = timeline.getBoundingClientRect();
      const view = window.innerHeight || 1;
      const start = view * 0.72;
      const end = view * 0.28;
      const raw = (start - rect.top) / (rect.height + (start - end));
      const pct = Math.max(0, Math.min(1, raw)) * 100;
      progress.style.height = pct + '%';

      milestones.forEach((el) => {
        const r = el.getBoundingClientRect();
        const active = r.top < view * 0.68 && r.bottom > view * 0.22;
        el.classList.toggle('is-active', active);
      });
    };

    if (reduceMotion) {
      progress.style.height = '100%';
      milestones.forEach((el) => el.classList.add('is-active'));
    } else {
      let ticking = false;
      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          update();
          ticking = false;
        });
      };

      update();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
    }

    const marquee = root.querySelector('[data-archive-marquee]');
    const track = root.querySelector('[data-archive-track]');
    if (!marquee || !track || reduceMotion) return;

    const originals = [...track.children];
    if (!originals.length) return;

    // Duplicate set so the strip can loop seamlessly.
    originals.forEach((node) => {
      const clone = node.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('img').forEach((img) => {
        img.setAttribute('loading', 'lazy');
        img.removeAttribute('fetchpriority');
      });
      track.appendChild(clone);
    });

    let offset = 0;
    let paused = false;
    let rafId = 0;
    const speed = 0.55;

    const loop = () => {
      if (!paused) {
        const half = track.scrollWidth / 2;
        if (half > 0) {
          offset += speed;
          if (offset >= half) offset -= half;
          track.style.transform = 'translate3d(' + -offset + 'px,0,0)';
        }
      }
      rafId = requestAnimationFrame(loop);
    };

    const pause = () => {
      paused = true;
    };
    const resume = () => {
      paused = false;
    };

    marquee.addEventListener('mouseenter', pause);
    marquee.addEventListener('mouseleave', resume);
    marquee.addEventListener('focusin', pause);
    marquee.addEventListener('focusout', resume);
    marquee.addEventListener(
      'touchstart',
      pause,
      { passive: true }
    );
    marquee.addEventListener(
      'touchend',
      () => {
        window.setTimeout(resume, 1600);
      },
      { passive: true }
    );

    rafId = requestAnimationFrame(loop);
    window.addEventListener(
      'beforeunload',
      () => {
        if (rafId) cancelAnimationFrame(rafId);
      },
      { once: true }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-values"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-about-values]').forEach((root) => {
    const tabs = [...root.querySelectorAll('[data-about-value-tab]')];
    const panels = [...root.querySelectorAll('[data-about-value-panel]')];
    if (!tabs.length) return;

    const activate = (index) => {
      tabs.forEach((tab, i) => {
        const on = i === index;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach((panel, i) => {
        const on = i === index;
        panel.classList.toggle('is-active', on);
        if (on) panel.removeAttribute('hidden');
        else panel.setAttribute('hidden', '');
      });
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(index));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-announcement-marquee]');
    if (!root) return;
    const track = root.querySelector('.announcement-bar__marquee-track');
    const groups = track ? [...track.querySelectorAll('.announcement-bar__marquee-group')] : [];
    if (!track || groups.length < 2) return;

    const fill = () => {
      const group = groups[0];
      // Add more message copies inside each group until one group ≥ viewport width
      while (group.scrollWidth < root.clientWidth && group.children.length < 20) {
        groups.forEach((g) => {
          const first = g.querySelector('.announcement-bar__marquee-item');
          if (!first) return;
          g.appendChild(first.cloneNode(true));
        });
      }
    };
    fill();
    window.addEventListener('resize', fill, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brands-grid"] && !Shopify.designMode) return;
  try {
    
  const getGridColumnCount = (element) => {
    const columns = window.getComputedStyle(element).gridTemplateColumns;
    if (!columns) return 1;
    return Math.max(1, columns.split(' ').filter(Boolean).length);
  };

  const sortByText = (elements, getText) =>
    [...elements].sort((a, b) =>
      getText(a).localeCompare(getText(b), 'fr', { sensitivity: 'base', numeric: true })
    );

  const reorderForColumnReading = (list) => {
    const items = sortByText(list.querySelectorAll(':scope > .brands-grid__item'), (item) =>
      (item.querySelector('.brands-grid__name') || item).textContent.trim()
    );
    const columns = getGridColumnCount(list);
    const rows = Math.ceil(items.length / columns);
    const reordered = [];

    for (let row = 0; row < rows; row += 1) {
      for (let column = 0; column < columns; column += 1) {
        const index = row + column * rows;
        if (items[index]) reordered.push(items[index]);
      }
    }

    reordered.forEach((item) => list.appendChild(item));
  };

  const syncAllBrandLists = () => {
    document.querySelectorAll('.brands-grid__list').forEach(reorderForColumnReading);
  };

  syncAllBrandLists();
  window.addEventListener('resize', syncAllBrandLists);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["design-service"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-ds-root]');
    if (!root) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* --- Hero fade slideshow --- */
    const slides = Array.from(root.querySelectorAll('[data-ds-slide]'));
    if (slides.length > 1 && !reduceMotion) {
      let current = 0;
      setInterval(() => {
        slides[current].classList.remove('is-active');
        current = (current + 1) % slides.length;
        slides[current].classList.add('is-active');
      }, 5000);
    }

    /* --- Range sliders --- */
    const syncRangeFill = (input) => {
      if (!input) return;
      const min = Number(input.min) || 0;
      const max = Number(input.max) || 100;
      const val = Number(input.value);
      const pct = max === min ? 0 : ((val - min) / (max - min)) * 100;
      input.style.setProperty('--range-pct', `${pct}%`);
    };

    const unit = root.querySelector('[data-ds-surface-out]')?.textContent.replace(/[\d\s\u00a0]+/g, '').trim() || 'm²';
    const surfaceRange = root.querySelector('[data-ds-surface-range]');
    const surfaceOut = root.querySelector('[data-ds-surface-out]');
    const surfaceHidden = root.querySelector('[data-ds-surface-hidden]');
    const syncSurface = () => {
      if (!surfaceRange) return;
      const v = surfaceRange.value;
      const label = v >= 400 ? `${v}+ ${unit}` : `${v} ${unit}`;
      if (surfaceOut) surfaceOut.textContent = label;
      if (surfaceHidden) surfaceHidden.value = label;
      syncRangeFill(surfaceRange);
    };
    surfaceRange?.addEventListener('input', syncSurface);
    syncSurface();

    const levelsRange = root.querySelector('[data-ds-levels-range]');
    const levelsOut = root.querySelector('[data-ds-levels-out]');
    const levelsHidden = root.querySelector('[data-ds-levels-hidden]');
    const syncLevels = () => {
      if (!levelsRange) return;
      const v = parseInt(levelsRange.value, 10);
      const label = v >= 3 ? '3+' : String(v);
      if (levelsOut) levelsOut.textContent = label;
      if (levelsHidden) levelsHidden.value = label;
      syncRangeFill(levelsRange);
    };
    levelsRange?.addEventListener('input', syncLevels);
    syncLevels();

    /* --- Brands see-more --- */
    const brandsToggle = root.querySelector('[data-ds-brands-toggle]');
    if (brandsToggle) {
      const hiddenBrands = Array.from(root.querySelectorAll('[data-ds-brand-item][hidden]'));
      brandsToggle.addEventListener('click', () => {
        const expanded = brandsToggle.getAttribute('aria-expanded') === 'true';
        hiddenBrands.forEach((item) => {
          item.hidden = expanded;
        });
        brandsToggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        brandsToggle.textContent = expanded
          ? brandsToggle.getAttribute('data-label-more')
          : brandsToggle.getAttribute('data-label-less');
      });
    }

    /* --- Sticky CTA --- */
    const sticky = root.querySelector('[data-ds-sticky]');
    const hero = root.querySelector('[data-ds-hero]');
    const formWrap = document.getElementById('DesignServiceForm');
    if (sticky && hero) {
      sticky.hidden = false;
      const update = () => {
        const heroBottom = hero.getBoundingClientRect().bottom;
        const pastHero = heroBottom < 0;
        let nearForm = false;
        if (formWrap) {
          const rect = formWrap.getBoundingClientRect();
          nearForm = rect.top < window.innerHeight && rect.bottom > 0;
        }
        sticky.classList.toggle('is-visible', pastHero && !nearForm);
      };
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    }

    /* --- Form: captcha + contact[body] builder --- */
    const form = document.getElementById('DesignServiceApplicationForm');
    if (!form) return;

    form.setAttribute('data-shopify-captcha', 'true');
    if (window.Shopify?.captcha?.protect) {
      window.Shopify.captcha.protect(form);
    }

    const bodyInput = form.querySelector('[data-ds-body]');
    const val = (id) => form.querySelector(`#${id}`)?.value?.trim() || '';
    const labelsFor = (sel, labelSel) =>
      Array.from(form.querySelectorAll(sel))
        .filter((el) => el.checked)
        .map((el) => {
          const label = el.closest('label');
          const node = labelSel ? label?.querySelector(labelSel) : null;
          return (node?.textContent || el.value || '').trim();
        })
        .filter(Boolean);

    form.addEventListener('submit', () => {
      if (!bodyInput) return;
      const spaces = labelsFor('[data-ds-space]', '.design-service__tile-label');
      const services = labelsFor('[data-ds-service]', '.design-service__service-title');
      const brands = labelsFor('[data-ds-brand]', null);
      bodyInput.value = [
        'DESIGN SERVICE REQUEST',
        '',
        `Name: ${val('DsFirst')} ${val('DsLast')}`.trim(),
        `Email: ${val('DsEmail')}`,
        `Phone: ${val('DsPhone')}`,
        `Budget: ${val('DsBudget')}`,
        `Meeting preference: ${val('DsMeeting')}`,
        `Surface: ${surfaceHidden?.value || '—'}`,
        `Levels: ${levelsHidden?.value || '—'}`,
        `Spaces: ${spaces.join(', ') || '—'}`,
        `Services: ${services.join(', ') || '—'}`,
        `Favourite brands: ${brands.join(', ') || '—'}`,
        `Style: ${val('DsStyle') || '—'}`,
        '',
        'Message:',
        val('DsMessage') || '—',
      ].join('\n');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-brands"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-featured-brands]');
    if (!root) return;
    const track = root.querySelector('[data-brands-track]');
    if (!track) return;

    // If too few logos, duplicate the first group content so the loop still fills the viewport
    const first = track.querySelector('.featured-brands__group');
    if (!first || first.children.length === 0) return;
    if (first.scrollWidth >= window.innerWidth * 0.6) return;

    const extras = Math.ceil((window.innerWidth * 0.8) / Math.max(first.scrollWidth, 1));
    for (let i = 0; i < extras; i++) {
      [...first.children].forEach((child) => {
        const clone = child.cloneNode(true);
        clone.setAttribute('tabindex', '-1');
        first.appendChild(clone);
      });
    }
    const second = track.querySelectorAll('.featured-brands__group')[1];
    if (second) {
      second.innerHTML = first.innerHTML;
      second.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-mega-menu"]) return;
  try {
    
  const getGridColumnCount = (element) => {
    const columns = window.getComputedStyle(element).gridTemplateColumns;
    if (!columns) return 1;
    return Math.max(1, columns.split(' ').filter(Boolean).length);
  };

  const sortByText = (elements, getText) =>
    [...elements].sort((a, b) =>
      getText(a).localeCompare(getText(b), 'fr', { sensitivity: 'base', numeric: true })
    );

  const reorderForColumnReading = (list) => {
    const items = sortByText(list.querySelectorAll(':scope > li'), (item) => item.textContent.trim());
    const columns = getGridColumnCount(list);
    const rows = Math.ceil(items.length / columns);
    const reordered = [];

    for (let row = 0; row < rows; row += 1) {
      for (let column = 0; column < columns; column += 1) {
        const index = row + column * rows;
        if (items[index]) reordered.push(items[index]);
      }
    }

    reordered.forEach((item) => list.appendChild(item));
  };

  const syncBrandMenus = () => {
    document.querySelectorAll('.mega-brands__links').forEach(reorderForColumnReading);
    document.querySelectorAll('#MobileBrands').forEach((panel) => {
      const links = sortByText(panel.querySelectorAll(':scope > a.mobile-nav__link'), (link) =>
        link.textContent.trim()
      );
      links.forEach((link) => panel.appendChild(link));
    });
  };

  syncBrandMenus();
  window.addEventListener('resize', syncBrandMenus);

  document.querySelectorAll('[data-mega-panel]').forEach((panel) => {
    panel.hidden = false;
    panel.setAttribute('hidden', '');
    let hideTimer = null;
    const observer = new MutationObserver(() => {
      clearTimeout(hideTimer);
      if (panel.classList.contains('is-open')) {
        panel.removeAttribute('hidden');
        return;
      }
      const done = () => {
        if (panel.classList.contains('is-open')) return;
        panel.setAttribute('hidden', '');
      };
      panel.addEventListener('transitionend', done, { once: true });
      hideTimer = setTimeout(done, 360);
    });
    observer.observe(panel, { attributes: true, attributeFilter: ['class'] });
  });

  document.querySelectorAll('[data-mega-close]').forEach((el) => {
    el.addEventListener('click', () => {
      document.querySelectorAll('[data-mega-panel].is-open').forEach((p) => {
        p.classList.remove('is-open');
        document.querySelectorAll(`[data-mega-trigger][aria-controls="${p.id}"]`).forEach((t) => {
          t.setAttribute('aria-expanded', 'false');
        });
      });
      document.body.classList.remove('search-dropdown-open');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  document.querySelectorAll('[data-edit-address]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const panel = document.getElementById('EditAddress-' + btn.getAttribute('data-edit-address'));
      if (panel) panel.hidden = !panel.hidden;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-main-collection]');
    if (!root) return;

    const sortSelect = root.querySelector('[data-collection-sort]');
    if (sortSelect) {
      sortSelect.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSelect.value);
        window.location.assign(url.toString());
      });
    }

    const drawer = root.querySelector('[data-filters-drawer]');
    const openBtn = root.querySelector('[data-filters-open]');
    if (!drawer || !openBtn) return;

    const closeBtns = drawer.querySelectorAll('[data-filters-close]');
    const panel = drawer.querySelector('.filters-drawer__panel');
    let lastFocus = null;

    const setOpen = (open) => {
      if (open) {
        lastFocus = document.activeElement;
        drawer.hidden = false;
        drawer.setAttribute('aria-hidden', 'false');
        openBtn.setAttribute('aria-expanded', 'true');
        requestAnimationFrame(() => {
          drawer.classList.add('is-open');
          const focusTarget = panel?.querySelector('[data-filters-close], summary, input, button, a');
          focusTarget?.focus({ preventScroll: true });
        });
        if (window.BP?.lockScroll) window.BP.lockScroll(true);
        else document.body.classList.add('scroll-lock');
      } else {
        drawer.classList.remove('is-open');
        openBtn.setAttribute('aria-expanded', 'false');
        drawer.setAttribute('aria-hidden', 'true');
        const done = () => {
          if (drawer.classList.contains('is-open')) return;
          drawer.hidden = true;
        };
        panel?.addEventListener('transitionend', done, { once: true });
        setTimeout(done, 420);
        if (window.BP?.lockScroll) window.BP.lockScroll(false);
        else document.body.classList.remove('scroll-lock');
        if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
      }
    };

    openBtn.addEventListener('click', () => setOpen(true));
    closeBtns.forEach((btn) => btn.addEventListener('click', () => setOpen(false)));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) setOpen(false);
    });

    const section = document.querySelector('[data-main-collection]');
    const defaultLabelMore = section?.dataset.labelMore || '';
    const defaultLabelLess = section?.dataset.labelLess || '';
    const defaultLabelNoProducts = section?.dataset.labelNoProducts || '';

    drawer.querySelectorAll('[data-filter-collapse]').forEach((list) => {
      const limit = Number(list.dataset.limit) || 8;
      const items = Array.from(list.children).filter((el) => el.tagName === 'LI');
      const group = list.closest('.filter-group') || list.parentElement;
      const toggle = group?.querySelector('[data-filter-collapse-toggle]');
      if (!toggle) return;
      if (items.length <= limit) {
        toggle.hidden = true;
        return;
      }

      const labelMore = toggle.dataset.labelMore || defaultLabelMore;
      const labelLess = toggle.dataset.labelLess || defaultLabelLess;
      let expanded = false;

      const apply = () => {
        let hiddenCount = 0;
        items.forEach((item, index) => {
          const keepVisible = item.querySelector('input:checked, .is-active');
          const shouldHide = !expanded && index >= limit && !keepVisible;
          item.hidden = shouldHide;
          if (shouldHide) hiddenCount += 1;
        });
        toggle.hidden = expanded ? false : hiddenCount === 0;
        toggle.setAttribute('aria-expanded', String(expanded));
        toggle.textContent = expanded ? labelLess : labelMore;
      };

      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        expanded = !expanded;
        apply();
      });
      apply();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-main-search]');
    if (!root) return;

    const drawer = root.querySelector('[data-filters-drawer]');
    const openBtn = root.querySelector('[data-filters-open]');
    if (drawer && openBtn) {
      const closeBtns = drawer.querySelectorAll('[data-filters-close]');
      const panel = drawer.querySelector('.filters-drawer__panel');
      let lastFocus = null;

      const setOpen = (open) => {
        if (open) {
          lastFocus = document.activeElement;
          drawer.hidden = false;
          drawer.setAttribute('aria-hidden', 'false');
          openBtn.setAttribute('aria-expanded', 'true');
          requestAnimationFrame(() => {
            drawer.classList.add('is-open');
            const focusTarget = panel?.querySelector('[data-filters-close], summary, input, button, a');
            focusTarget?.focus({ preventScroll: true });
          });
          if (window.BP?.lockScroll) window.BP.lockScroll(true);
          else document.body.classList.add('scroll-lock');
        } else {
          drawer.classList.remove('is-open');
          openBtn.setAttribute('aria-expanded', 'false');
          drawer.setAttribute('aria-hidden', 'true');
          const done = () => {
            if (drawer.classList.contains('is-open')) return;
            drawer.hidden = true;
          };
          panel?.addEventListener('transitionend', done, { once: true });
          setTimeout(done, 420);
          if (window.BP?.lockScroll) window.BP.lockScroll(false);
          else document.body.classList.remove('scroll-lock');
          if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
        }
      };

      openBtn.addEventListener('click', () => setOpen(true));
      closeBtns.forEach((btn) => btn.addEventListener('click', () => setOpen(false)));
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && drawer.classList.contains('is-open')) setOpen(false);
      });

      const defaultLabelMore = root.dataset.labelMore || '';
      const defaultLabelLess = root.dataset.labelLess || '';
      drawer.querySelectorAll('[data-filter-collapse]').forEach((list) => {
        const limit = Number(list.dataset.limit) || 8;
        const items = Array.from(list.children).filter((el) => el.tagName === 'LI');
        const group = list.closest('.filter-group') || list.parentElement;
        const toggle = group?.querySelector('[data-filter-collapse-toggle]');
        if (!toggle) return;
        if (items.length <= limit) {
          toggle.hidden = true;
          return;
        }
        const labelMore = toggle.dataset.labelMore || defaultLabelMore;
        const labelLess = toggle.dataset.labelLess || defaultLabelLess;
        let expanded = false;
        const apply = () => {
          let hiddenCount = 0;
          items.forEach((item, index) => {
            const keepVisible = item.querySelector('input:checked, .is-active');
            const shouldHide = !expanded && index >= limit && !keepVisible;
            item.hidden = shouldHide;
            if (shouldHide) hiddenCount += 1;
          });
          toggle.hidden = expanded ? false : hiddenCount === 0;
          toggle.setAttribute('aria-expanded', String(expanded));
          toggle.textContent = expanded ? labelLess : labelMore;
        };
        toggle.addEventListener('click', (e) => {
          e.preventDefault();
          expanded = !expanded;
          apply();
        });
        apply();
      });
    }

    const fallbackRoot = document.querySelector('[data-search-fallback]');
    if (!fallbackRoot) return;

    const terms = (fallbackRoot.getAttribute('data-search-terms') || '').trim();
    const predictUrl = fallbackRoot.getAttribute('data-predictive-url');
    const brandUrl = fallbackRoot.getAttribute('data-brand-url');
    const vendorUrl = fallbackRoot.getAttribute('data-vendor-filter-url');
    if (!terms || !predictUrl) return;

    if (brandUrl) {
      window.location.replace(brandUrl);
      return;
    }
    if (vendorUrl) {
      window.location.replace(vendorUrl);
      return;
    }

    const grid = fallbackRoot.querySelector('[data-search-fallback-grid]');
    const empty = fallbackRoot.querySelector('[data-search-empty]');
    const lede = fallbackRoot.querySelector('[data-search-lede]');
    const count = fallbackRoot.querySelector('[data-search-count]');
    const quoteLabel = fallbackRoot.getAttribute('data-quote-label') || '';
    const forTerms = fallbackRoot.getAttribute('data-for-terms') || '';
    const countOne = fallbackRoot.getAttribute('data-products-count-one') || '1 product';
    const countMany = fallbackRoot.getAttribute('data-products-count-many') || '9 products';

    const escapeHtml = (value) =>
      String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');

    const cardHtml = (product) => {
      const href = product.url || `/products/${product.handle}`;
      const title = escapeHtml(product.title);
      const vendor = escapeHtml(product.vendor || '');
      const image = product.image
        ? `<img class="product-card__img product-card__img--primary" src="${escapeHtml(product.image)}" alt="${title}" loading="lazy" decoding="async" width="800" height="800">`
        : '';
      return `<a class="product-card" href="${escapeHtml(href)}">
        <div class="product-card__media">${image}</div>
        <div class="product-card__meta">
          <h3 class="product-card__title">${title}</h3>
          ${vendor ? `<p class="product-card__brand">${vendor}</p>` : ''}
          ${quoteLabel ? `<p class="product-card__enquire">${escapeHtml(quoteLabel)}</p>` : ''}
        </div>
      </a>`;
    };

    fetch(
      `${predictUrl}.json?q=${encodeURIComponent(terms)}&resources[type]=product&resources[limit]=10`
    )
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        const products = data?.resources?.results?.products || [];
        if (!products.length || !grid) return;

        grid.innerHTML = products.map(cardHtml).join('');
        grid.hidden = false;
        if (empty) empty.hidden = true;
        if (lede && forTerms) lede.textContent = forTerms;
        if (count) {
          const n = products.length;
          const template = n === 1 ? countOne : countMany;
          count.textContent = template.replace(/\d+/, String(n));
        }
      })
      .catch(() => {});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-configurator"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.getElementById('ProductConfigurator');
    if (!root) return;

    const iframe = root.querySelector('iframe');
    const stage = root.querySelector('[data-configurator-stage]');
    const modal = root.querySelector('[data-configurator-lead-modal]');
    const form = modal?.querySelector('form');
    const emailInput = form?.querySelector('[data-configurator-lead-email]');
    const emailError = form?.querySelector('[data-configurator-lead-email-error]');
    const statusEl = form?.querySelector('[data-configurator-lead-status]');
    const submitBtn = form?.querySelector('[data-configurator-lead-submit]');
    const reopenBtn = root.querySelector('[data-configurator-lead-reopen]');
    const mobileOpenBtn = root.querySelector('[data-configurator-mobile-open]');
    const MOBILE_MQ = window.matchMedia('(max-width: 768px)');
    const isMobile = () => MOBILE_MQ.matches;
    /* v2: previous unlocks could succeed without a real /contact POST (no email). */
    const STORAGE_KEY = 'bp_configurator_lead_v2';
    const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

    let requiresLead = root.getAttribute('data-configurator-get-lead') !== 'false';
    let leadDismissed = false;

    const setReopenVisible = (visible) => {
      if (!reopenBtn) return;
      reopenBtn.hidden = !visible;
    };

    const setMobileGateVisible = (visible) => {
      if (!mobileOpenBtn || !isMobile()) return;
      mobileOpenBtn.hidden = !visible;
    };

    const activateMobileStage = () => {
      stage?.classList.add('is-mobile-open');
      root.classList.add('is-mobile-active');
      setMobileGateVisible(false);
    };

    const openMobileConfigurator = () => {
      scrollToConfigurator();
      activateMobileStage();
      if (canLoad()) {
        loadIframes();
      } else {
        leadDismissed = false;
        showLead();
      }
    };

    const isUnlocked = () => {
      try {
        return Boolean(localStorage.getItem(STORAGE_KEY));
      } catch (_) {
        return false;
      }
    };

    const unlock = (payload = {}) => {
      try {
        localStorage.setItem(
          STORAGE_KEY,
          JSON.stringify({
            email: payload.email || '',
            ts: Date.now(),
          })
        );
      } catch (_) {}
    };

    const canLoad = () => !requiresLead || isUnlocked();

    /* Same pattern as PDP quote form (product-page.js): protect() only, native submit. */
    const protectCaptcha = () => {
      if (!form) return;
      form.removeAttribute('target');
      form.setAttribute('data-shopify-captcha', 'true');
      try {
        if (window.Shopify?.captcha?.protect) {
          window.Shopify.captcha.protect(form);
        }
      } catch (_) {}
    };

    const PENDING_KEY = 'bp_configurator_lead_pending';

    const markPendingLead = (email) => {
      try {
        sessionStorage.setItem(
          PENDING_KEY,
          JSON.stringify({ email: email || '', ts: Date.now() })
        );
      } catch (_) {}
    };

    const consumePendingLead = () => {
      try {
        const raw = sessionStorage.getItem(PENDING_KEY);
        if (!raw) return null;
        sessionStorage.removeItem(PENDING_KEY);
        const data = JSON.parse(raw);
        if (!data || Date.now() - (data.ts || 0) > 120000) return null;
        return data;
      } catch (_) {
        try {
          sessionStorage.removeItem(PENDING_KEY);
        } catch (__) {}
        return null;
      }
    };

    const openConfiguratorAfterLead = () => {
      activateMobileStage();
      hideLead();
      setReopenVisible(false);
      loadIframes();
      scrollToConfigurator();
      if (history.replaceState) {
        history.replaceState(null, '', `${window.location.pathname}${window.location.search}#ProductConfigurator`);
      }
    };

    const showLead = () => {
      if (!modal || canLoad()) return;
      leadDismissed = false;
      setReopenVisible(false);
      modal.hidden = false;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      if (isMobile()) {
        modal.classList.add('configurator-lead-modal--viewport');
        document.body.classList.add('configurator-lead-open');
        activateMobileStage();
      }
      protectCaptcha();
    };

    const hideLead = ({ dismissed = false } = {}) => {
      if (!modal) return;
      modal.classList.remove('is-open');
      modal.classList.remove('configurator-lead-modal--viewport');
      modal.setAttribute('aria-hidden', 'true');
      modal.hidden = true;
      document.body.classList.remove('configurator-lead-open');
      if (dismissed && !canLoad()) {
        leadDismissed = true;
        setReopenVisible(true);
        if (isMobile() && stage?.classList.contains('is-mobile-open')) {
          setMobileGateVisible(false);
        }
      } else {
        setReopenVisible(false);
      }
    };

    const scrollToConfigurator = () => {
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    const loadIframes = (scope = root) => {
      if (!canLoad()) {
        showLead();
        return false;
      }
      hideLead();
      setReopenVisible(false);
      scope.querySelectorAll('iframe[data-src]').forEach((el) => {
        const src = el.dataset.src;
        if (src && !el.getAttribute('src')) {
          el.src = src;
        }
      });
      return true;
    };

    /* After Shopify contact POST reload (?contact_posted=true), unlock + open 3D. */
    (() => {
      let posted = false;
      try {
        posted = new URLSearchParams(window.location.search).get('contact_posted') === 'true';
      } catch (_) {}
      const liquidPosted = Boolean(modal?.querySelector('[data-configurator-lead-posted]'));
      const pending = consumePendingLead();
      if (!posted && !liquidPosted) {
        /* Pending alone is not enough (failed captcha can still reload). */
        return;
      }
      unlock({ email: (pending?.email || emailInput?.value || '').trim() });
      try {
        const params = new URLSearchParams(window.location.search);
        params.delete('contact_posted');
        const qs = params.toString();
        history.replaceState(
          null,
          '',
          `${window.location.pathname}${qs ? `?${qs}` : ''}#ProductConfigurator`
        );
      } catch (_) {}
      openConfiguratorAfterLead();
    })();

    const resolveUrl = (detail = {}) => {
      if (detail.configuratorUrl) return detail.configuratorUrl;
      const productForm = document.querySelector('[data-product-form]');
      const select = productForm?.querySelector('[name="id"]');
      if (!select) return root.getAttribute('data-product-configurator-url') || '';
      const option =
        select.tagName === 'SELECT' ? select.options[select.selectedIndex] : select;
      return (
        option?.dataset?.configuratorUrl ||
        root.getAttribute('data-product-configurator-url') ||
        ''
      ).trim();
    };

    const resolveGetLead = (detail = {}) => {
      if (typeof detail.configuratorGetLead === 'boolean') return detail.configuratorGetLead;
      if (detail.configuratorGetLead === 'true' || detail.getLead === true) return true;
      if (detail.configuratorGetLead === 'false' || detail.getLead === false) return false;
      const productForm = document.querySelector('[data-product-form]');
      const select = productForm?.querySelector('[name="id"]');
      const option =
        select?.tagName === 'SELECT' ? select.options[select.selectedIndex] : select;
      if (option?.dataset?.configuratorGetLead === 'false') return false;
      if (option?.dataset?.configuratorGetLead === 'true') return true;
      return root.getAttribute('data-configurator-get-lead') !== 'false';
    };

    const applyUrl = (url, detail = {}) => {
      const next = (url || '').trim();
      const has = Boolean(next);
      requiresLead = resolveGetLead(detail);
      root.setAttribute('data-configurator-get-lead', requiresLead ? 'true' : 'false');
      root.hidden = !has;
      document.querySelectorAll('[data-configurator-cta-wrap]').forEach((el) => {
        el.hidden = !has;
      });
      document.querySelectorAll('[data-configurator-price-note]').forEach((el) => {
        el.hidden = !has;
      });
      if (!iframe || !has) return;

      const current = iframe.getAttribute('src') || iframe.dataset.src || '';
      if (current === next) return;

      iframe.dataset.src = next;
      if (iframe.getAttribute('src') && canLoad()) {
        iframe.src = next;
      } else if (!canLoad() && iframe.getAttribute('src')) {
        iframe.removeAttribute('src');
      }
    };

    const observeTarget = stage || iframe;
    if (observeTarget && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            if (isMobile() && !stage?.classList.contains('is-mobile-open')) {
              setMobileGateVisible(true);
              return;
            }
            if (canLoad()) {
              loadIframes();
              io.unobserve(entry.target);
              return;
            }
            if (!leadDismissed) showLead();
            else setReopenVisible(true);
          });
        },
        { rootMargin: '80px 0px', threshold: 0.2 }
      );
      io.observe(observeTarget);
    } else if (canLoad()) {
      loadIframes();
    }

    document.querySelectorAll('[data-scroll-to-configurator]').forEach((link) => {
      link.dataset.bpScrollBound = 'true';
      link.addEventListener('click', (e) => {
        e.preventDefault();
        if (isMobile()) {
          openMobileConfigurator();
        } else {
          scrollToConfigurator();
          if (canLoad()) {
            loadIframes();
          } else {
            leadDismissed = false;
            showLead();
          }
        }
        if (history.replaceState) {
          history.replaceState(null, '', '#ProductConfigurator');
        }
      });
    });

    document.addEventListener('bp:configurator:open', () => {
      if (isMobile()) {
        openMobileConfigurator();
        return;
      }
      if (canLoad()) {
        loadIframes();
      } else {
        leadDismissed = false;
        showLead();
      }
    });

    if (window.location.hash === '#ProductConfigurator') {
      if (isMobile()) {
        openMobileConfigurator();
      } else {
        scrollToConfigurator();
        if (canLoad()) {
          loadIframes();
        } else {
          showLead();
        }
      }
    }

    mobileOpenBtn?.addEventListener('click', () => {
      openMobileConfigurator();
    });

    modal?.querySelectorAll('[data-configurator-lead-close]').forEach((btn) => {
      btn.addEventListener('click', () => {
        hideLead({ dismissed: true });
      });
    });

    reopenBtn?.addEventListener('click', () => {
      showLead();
    });

    document.addEventListener('bp:variant:change', (e) => {
      const detail = e.detail || {};
      applyUrl(resolveUrl(detail), detail);
      const skuInput = form?.querySelector('[data-configurator-lead-sku]');
      const productForm = detail.form || document.querySelector('[data-product-form]');
      const select = productForm?.querySelector('[name="id"]');
      const option =
        select?.tagName === 'SELECT' ? select.options[select.selectedIndex] : select;
      if (skuInput && option?.dataset?.sku) skuInput.value = option.dataset.sku;
    });

    applyUrl(resolveUrl());

    if (form) {
      const loaderEl = modal?.querySelector('[data-configurator-lead-loader]');
      const submitLabel = submitBtn?.querySelector('[data-configurator-lead-submit-label]');
      const submitLoading = submitBtn?.querySelector('[data-configurator-lead-submit-loading]');
      const bodyInput = form.querySelector('[data-configurator-lead-body]');
      const nameInput = form.querySelector('[data-configurator-lead-name]');

      const setSubmitting = (on) => {
        if (submitBtn) submitBtn.disabled = on;
        if (submitLabel) submitLabel.hidden = on;
        if (submitLoading) submitLoading.hidden = !on;
        if (loaderEl) {
          loaderEl.hidden = !on;
          loaderEl.setAttribute('aria-hidden', on ? 'false' : 'true');
        }
        modal?.classList.toggle('is-submitting', on);
      };

      const fillLeadPayload = (email) => {
        const first = (form.querySelector('[name="contact[first_name]"]')?.value || '').trim();
        const last = (form.querySelector('[name="contact[last_name]"]')?.value || '').trim();
        const country = (form.querySelector('[name="contact[country]"]')?.value || '').trim();
        const product = (form.querySelector('[name="contact[product]"]')?.value || '').trim();
        const brand = (form.querySelector('[name="contact[brand]"]')?.value || '').trim();
        const productUrl = (form.querySelector('[name="contact[product_url]"]')?.value || '').trim();
        const sku = (form.querySelector('[name="contact[sku]"]')?.value || '').trim();
        const fullName = [first, last].filter(Boolean).join(' ');
        if (nameInput) nameInput.value = fullName;
        if (bodyInput) {
          bodyInput.value = [
            'Lead configurateur 3D',
            '',
            `Name: ${fullName}`,
            `Email: ${email}`,
            `Country: ${country}`,
            `Brand: ${brand}`,
            `Product: ${product}`,
            sku ? `SKU: ${sku}` : '',
            productUrl ? `URL: ${productUrl}` : '',
          ]
            .filter(Boolean)
            .join('\n');
        }
      };

      /*
        Match PDP quote / design-service: protect(form) + natural submit.
        Only preventDefault when validation fails — never iframe/popup/fetch.
        @see https://shopify.dev/docs/storefronts/themes/trust-security/captcha
      */
      protectCaptcha();

      form.addEventListener('submit', (e) => {
        if (statusEl) {
          statusEl.hidden = true;
          statusEl.textContent = '';
        }
        if (emailError) emailError.hidden = true;

        const email = (emailInput?.value || '').trim();
        if (!EMAIL_RE.test(email)) {
          e.preventDefault();
          if (emailError) emailError.hidden = false;
          emailInput?.focus();
          return;
        }

        fillLeadPayload(email);
        markPendingLead(email);
        setSubmitting(true);
      });
    }

    const getFullscreenEl = () =>
      document.fullscreenElement || document.webkitFullscreenElement || null;

    const nudgeResize = (wrap) => {
      const frame = wrap.querySelector('iframe');
      if (!frame) return;
      requestAnimationFrame(() => {
        try {
          frame.contentWindow?.dispatchEvent(new Event('resize'));
        } catch (_) {}
        window.dispatchEvent(new Event('resize'));
      });
    };

    const syncFsButton = (wrap) => {
      const on = getFullscreenEl() === wrap || wrap.classList.contains('is-fullscreen');
      const btn = wrap.querySelector('[data-configurator-fs]');
      const openLabel = btn?.querySelector('[data-configurator-fs-open]');
      const closeLabel = btn?.querySelector('[data-configurator-fs-close]');
      if (btn) btn.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (openLabel) openLabel.hidden = on;
      if (closeLabel) closeLabel.hidden = !on;
      if (on) {
        loadIframes(wrap);
        nudgeResize(wrap);
      }
    };

    const supportsNativeFs = (el) =>
      Boolean(el && (el.requestFullscreen || el.webkitRequestFullscreen));

    const enterNativeFs = (el) => {
      if (el.requestFullscreen) return el.requestFullscreen();
      if (el.webkitRequestFullscreen) return el.webkitRequestFullscreen();
      return Promise.reject(new Error('fullscreen unsupported'));
    };

    const exitNativeFs = () => {
      if (document.exitFullscreen) return document.exitFullscreen();
      if (document.webkitExitFullscreen) return document.webkitExitFullscreen();
      return Promise.resolve();
    };

    const exitCssFs = (wrap) => {
      wrap.classList.remove('is-fullscreen');
      document.body.classList.remove('configurator-fs-open');
    };

    const enterCssFs = (wrap) => {
      wrap.classList.add('is-fullscreen');
      document.body.classList.add('configurator-fs-open');
    };

    const toggleFullscreen = async (wrap) => {
      if (getFullscreenEl() === wrap) {
        try {
          await exitNativeFs();
        } catch (_) {}
        syncFsButton(wrap);
        return;
      }

      if (wrap.classList.contains('is-fullscreen')) {
        exitCssFs(wrap);
        syncFsButton(wrap);
        return;
      }

      if (!loadIframes(wrap)) return;

      if (supportsNativeFs(wrap)) {
        try {
          await enterNativeFs(wrap);
          syncFsButton(wrap);
          return;
        } catch (_) {
          /* fall through to CSS fullscreen */
        }
      }

      enterCssFs(wrap);
      syncFsButton(wrap);
    };

    root.querySelectorAll('[data-configurator-iframe]').forEach((wrap) => {
      const btn = wrap.querySelector('[data-configurator-fs]');
      if (!btn) return;
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleFullscreen(wrap);
      });
    });

    const onFsChange = () => {
      root.querySelectorAll('[data-configurator-iframe]').forEach((wrap) => {
        if (getFullscreenEl() === wrap) {
          exitCssFs(wrap);
        }
        syncFsButton(wrap);
      });
    };
    document.addEventListener('fullscreenchange', onFsChange);
    document.addEventListener('webkitfullscreenchange', onFsChange);

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      root.querySelectorAll('[data-configurator-iframe]').forEach((wrap) => {
        if (getFullscreenEl() === wrap) {
          exitNativeFs().catch(() => {});
        }
        if (wrap.classList.contains('is-fullscreen')) {
          exitCssFs(wrap);
        }
        syncFsButton(wrap);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saved-projects"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const KEY = 'bp_saved_projects_v1';
    const root = document.querySelector('[data-saved-projects]');
    if (!root) return;

    function read() {
      try {
        return JSON.parse(localStorage.getItem(KEY) || '[]');
      } catch (e) {
        return [];
      }
    }
    function write(projects) {
      localStorage.setItem(KEY, JSON.stringify(projects));
      render();
    }
    function render() {
      const list = root.querySelector('[data-projects-list]');
      const projects = read();
      const emptyMsg = root.dataset.msgEmpty || 'No projects yet.';
      const emptyItemsMsg = root.dataset.msgEmptyItems || 'Empty';
      if (!projects.length) {
        list.innerHTML = `<p class="text-muted">${emptyMsg}</p>`;
        return;
      }
      list.innerHTML = projects
        .map((p) => {
          const items = (p.items || [])
            .map((i) => {
              const label = i.url
                ? `<a href="${i.url}">${i.title}</a>`
                : `<span>${i.title}</span>`;
              return `<li>${label}<button type="button" data-remove-item="${p.id}" data-item-key="${i.key}">×</button></li>`;
            })
            .join('');
          return `<article class="saved-project" data-project-id="${p.id}">
            <div class="saved-project__header">
              <h2>${p.name}</h2>
            </div>
            <ul class="saved-project__items">${items || `<li class="text-muted">${emptyItemsMsg}</li>`}</ul>
          </article>`;
        })
        .join('');
    }

    root.querySelector('[data-create-project]')?.addEventListener('click', () => {
      const input = root.querySelector('[data-new-project-name]');
      const name = (input.value || '').trim();
      if (!name) return;
      const projects = read();
      projects.push({ id: String(Date.now()), name, items: [] });
      write(projects);
      input.value = '';
    });

    window.BP = window.BP || {};
    BP.Projects = {
      addToProject(projectId, item) {
        const projects = read();
        const project = projects.find((p) => p.id === projectId);
        if (!project) return;
        project.items = project.items || [];
        if (!project.items.some((x) => x.key === item.key)) project.items.push(item);
        write(projects);
      },
    };

    root.addEventListener('click', (e) => {
      const remove = e.target.closest('[data-remove-item]');
      if (!remove) return;
      const projectId = remove.getAttribute('data-remove-item');
      const itemKey = remove.getAttribute('data-item-key');
      const projects = read();
      const project = projects.find((p) => p.id === projectId);
      if (!project) return;
      project.items = (project.items || []).filter((i) => i.key !== itemKey);
      write(projects);
    });

    render();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trade-apply"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const form = document.getElementById('TradeApplicationForm') || document.querySelector('form.trade-page__form');
    if (!form) return;

    form.setAttribute('data-shopify-captcha', 'true');
    if (window.Shopify?.captcha?.protect) {
      window.Shopify.captcha.protect(form);
    }

    const bodyInput = form.querySelector('[data-trade-body]');
    const modeInput = form.querySelector('[data-trade-mode-input]');
    const modeButtons = [...document.querySelectorAll('[data-trade-mode-btn]')];
    const panels = [...document.querySelectorAll('[data-trade-panel]')];
    const conditionalFields = [...document.querySelectorAll('[data-trade-only]')];
    const val = (id) => form.querySelector(`#${id}`)?.value?.trim() || '';

    const setRequired = (selector, required) => {
      form.querySelectorAll(selector).forEach((field) => {
        if (required) {
          field.setAttribute('required', '');
        } else {
          field.removeAttribute('required');
        }
      });
    };

    const root = document.getElementById('TradeAccess');
    const inquiryApply = root?.dataset.inquiryApply || 'Join the program';
    const inquiryCall = root?.dataset.inquiryCall || 'Schedule a call';

    const applyMode = (mode) => {
      if (modeInput) {
        modeInput.value = mode === 'call' ? inquiryCall : inquiryApply;
      }

      modeButtons.forEach((btn) => {
        const active = btn.dataset.mode === mode;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      panels.forEach((panel) => {
        panel.classList.toggle('is-hidden', panel.dataset.tradePanel !== mode);
      });

      conditionalFields.forEach((group) => {
        const active = group.dataset.tradeOnly === mode;
        group.classList.toggle('is-hidden', !active);
      });

      setRequired('#TradeAddress, #TradeCity, #TradePostal', mode === 'apply');
      setRequired('#TradePreferredDate, #TradePreferredTime, #TradePreferredTimezone', mode === 'call');
    };

    modeButtons.forEach((btn) => {
      btn.addEventListener('click', () => applyMode(btn.dataset.mode || 'apply'));
    });

    applyMode('apply');

    form.addEventListener('submit', () => {
      if (!bodyInput) return;
      const inquiryType = modeInput?.value || inquiryApply;
      bodyInput.value = [
        'TRADE INQUIRY',
        '',
        `Inquiry type: ${inquiryType}`,
        `Name: ${val('TradeFirst')} ${val('TradeLast')}`,
        `Email: ${val('TradeEmail')}`,
        `Phone: ${val('TradePhone')}`,
        `Company: ${val('TradeCompany')}`,
        `Profession: ${val('TradeProfession')}`,
        `Website: ${val('TradeWebsite')}`,
        `Country: ${val('TradeCountry')}`,
        `SIRET / Company ID: ${val('TradeSiret')}`,
        `VAT: ${val('TradeVat')}`,
        `Address: ${val('TradeAddress')}`,
        `City: ${val('TradeCity')}`,
        `Postal code: ${val('TradePostal')}`,
        `Preferred date: ${val('TradePreferredDate')}`,
        `Preferred time: ${val('TradePreferredTime')}`,
        `Timezone: ${val('TradePreferredTimezone')}`,
        '',
        'Message:',
        val('TradeMessage'),
      ].join('\n');
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
